import { useState, type FormEvent } from 'react';
import { apiRequest } from '../api/client.js';

export const SetupRoute = () => {
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    setBusy(true);
    setMessage(null);
    try {
      await apiRequest('/setup', { method: 'POST', body: { email: data.get('email'), password: data.get('password') } });
      setMessage('Administrador criado. Volte à tela de entrada para continuar.');
    } catch {
      setMessage('A configuração inicial não está disponível ou os dados são inválidos.');
    } finally {
      setBusy(false);
    }
  };
  return <main className="auth-stage">
    <section className="auth-sheet" aria-labelledby="setup-title">
      <Brand />
      <h1 id="setup-title">Configuração inicial</h1>
      <p>Crie o único administrador da instalação. Esta rota só funciona pelo acesso local seguro.</p>
      <form onSubmit={(event) => void submit(event)}>
        <label htmlFor="setup-email">E-mail do administrador</label>
        <input id="setup-email" name="email" type="email" autoComplete="username" required />
        <label htmlFor="setup-password">Senha do administrador</label>
        <input id="setup-password" name="password" type="password" autoComplete="new-password" minLength={12} required />
        <button type="submit" disabled={busy}>{busy ? 'Criando…' : 'Criar administrador'}</button>
      </form>
      {message === null ? null : <p role="status" className="form-message">{message}</p>}
    </section>
  </main>;
};

export const Brand = () => <div className="brand" aria-label="DreamTech Disparos">
  <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6 5h12l8 8v14H6z"/><path d="M11 11h7M11 16h10M11 21h7"/></svg>
  <span>DreamTech <strong>Disparos</strong></span>
</div>;
